import { render, staticRenderFns } from "./CellInformationModal.vue?vue&type=template&id=87576ec8&scoped=true"
import script from "./CellInformationModal.vue?vue&type=script&lang=js"
export * from "./CellInformationModal.vue?vue&type=script&lang=js"
import style0 from "./CellInformationModal.vue?vue&type=style&index=0&id=87576ec8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87576ec8",
  null
  
)

export default component.exports